import React from "react";
import Advertise from "./Advertise";
const Banner = () => {
  return (
    <section className="banner-section section-padding" id="banner">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-4 mb-0">
            {/* <div
              className="p-4 border rounded shadow"
              style={{ border: "1px solid black" }}
            >
              <h4 className="text-center">Banner</h4>
              <p className="text-center">
                Place your ad content here. This space can be used for banners,
                promotions, or other information.
              </p>
            </div> */}
            <Advertise 
              adClient="ca-pub-8380106160291700" 
              adSlot="5062524459" 
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
